import React from 'react';

import ReceitasExib from '../components/receitasExib';
import Breadcumb from '../components/Breadcumb';
import SlideBc from '../components/slideBc';
import Footer from '../components/Footer';

class ExibirReceitas extends React.Component{
    render(){
        return(
            <div>
            <SlideBc/>
            <Breadcumb pageName="Receitas"/>
            <div className="container-fluid">
                <ReceitasExib/>
            </div>
            <Footer/>
        </div>
        );
    }
}

export default ExibirReceitas